

export default{
    overview: 'Επισκόπηση πελάτη',
    back:'Επιστροφή στα διατροφικά πλάνα του πελάτη',
    tabs: {
        base: {
            title: 'Στοιχεία',
            subtitle: 'Βασικές πληροφορίες'
        },
        progress: {
            title: 'Φύλλο παρακολούθησης',
            subtitle: 'Πρόοδος ανά ραντεβού'
        },
        dietPlans: {
            title: 'Διατροφικά Πλάνα',
            subtitle: 'Εβδομαδιαία προγράμματα',
        },
        measures: {
            title: 'Μετρήσεις',
            subtitle: 'Σωματομετρικές, αιματολογικές'
        },
        sports: {
            title: 'Άσκηση & Συμπληρώματα',
            subtitle: 'Άσκηση & συνιστώμενα συμπληρώματα'
        },
        questionnaire: {
            title: 'Ερωτηματολόγιο',
            subtitle: 'Σύντομο / αναλυτικό ερωτηματολόγιο'
        },
        mobile: {
            title: 'Mobile Εφαρμογή',
            subtitle: 'Ημερολόγιο καταγραφής - στόχοι'
        },
        files: {
            title: 'Αρχεία',
            subtitle: 'Αποθηκευμένα αρχεία πελάτη'
        },
    },
    age: 'Ηλικία',
    year:'έτη',
    years:'ετών',
    appointmentHistory: 'Ιστορικότητα ραντεβού',
    delete: 'Διαγραφή πελάτη',
    disconnectApp: 'Αποσύνδεσε πρώτα το mobile app για να διαγράψεις τον πελάτη.',
    emailLockedByApp: 'Κλειδωμένο όσο είναι συνδεδεμένο το mobile app.',
    goals: {
        title: '',
        completed: 'Εκπληρωμένοι',
        nonCompleted: 'Ανεκπλήρωτοι',
        goal: 'Στόχος',
        goals: 'Στόχοι',
        goalPlaceholder: 'Προσθήκη νέου στόχου',
        targetDate: 'Εκπλήρωση στόχου έως',
        completionDate: 'Ημερομηνία ολοκλήρωσης'
    },
    events: {
        future: 'Μελλοντικά',
        past: 'Ολοκληρωμένα',
        cancelled: 'ακυρωμένο',
        approved: 'επιβεβαιωμένο',
        emptyFuture: 'Κανένα προγραμματισμένο ραντεβού',
        emptyFutureHint: 'Τα επόμενα ραντεβού με τον πελάτη θα εμφανίζονται εδώ.',
        emptyPast: 'Κανένα ραντεβού στο ιστορικό',
        emptyPastHint: 'Τα ολοκληρωμένα ραντεβού θα εμφανίζονται εδώ.'
    },
    absolutePercentage: 'Απόλυτη μεταβολή',
    percentage: 'Ποσοστιαία μεταβολή',
    weightChange: 'Μεταβολή βάρους',
    fatChange: 'Μεταβολή λίπους',
    fromFirst: '(από την 1η συνεδρία)',
    addProgressItem: 'Προσθήκη εγγραφής',
    editProgressItem: 'Επεξεργασία εγγραφής',
    invalidData: 'Παρακαλώ εισάγετε όλα τα υποχρεωτικά στοιχεία για να δημιουργήσετε τον πελάτη.',
    shareMeasurements: 'Κοινοποίηση μετρήσεων σε mobile εφαρμογή',

    pregnancy: {
        title: 'Εγκυμοσύνη',
        empty: {
            title: 'Δεν υπάρχει καταγεγραμμένη εγκυμοσύνη',
            subtitle: 'Ξεκίνα την παρακολούθηση εγκυμοσύνης για να καταγράφεις την πορεία της.',
            start: 'Έναρξη παρακολούθησης'
        }
    }
}
